import { API } from "@/lib/api";
import { APIService, FetchListRequest } from "@/services/api";
import { ReadTaxStatus, WriteTaxStatus } from "@/types/taxStatus";

export const taxStatusService = new APIService<ReadTaxStatus, WriteTaxStatus>(
  API.TaxStatuses,
);

export const TaxStatusService = {
  // API returns array of strings, but we need to return array of objects to
  getList: async (fetchParams?: FetchListRequest<ReadTaxStatus>) => {
    const statuses = await taxStatusService.getList<string[]>(fetchParams);
    const items = statuses.map((status) => ({
      name: status,
      id: status,
    }));
    return {
      items,
      count: items.length,
    };
  },
};
